module.exports = __webpack_public_path__ + "0acf0784970523e6bc838a1ed87cff44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/files.svg
// module id = 2817
// module chunks = 1